(function(){
  var STORAGE='novari_cozy_cat_timer_v2';
  var DURATION=15*60*1000;
  function mount(){
    document.querySelectorAll('[data-nc-holiday]').forEach(function(root){
      if(root.dataset.timerMounted==='true')return;
      root.dataset.timerMounted='true';
      var target=Date.now()+DURATION;
      try{
        var saved=Number(sessionStorage.getItem(STORAGE));
        if(Number.isFinite(saved)&&saved>Date.now()&&saved<=Date.now()+DURATION){target=saved;}
        else{sessionStorage.setItem(STORAGE,String(target));}
      }catch(e){}
      var minute=root.querySelector('[data-nc-minutes]');
      var second=root.querySelector('[data-nc-seconds]');
      var timer;
      function draw(){
        var remain=Math.max(0,Math.ceil((target-Date.now())/1000));
        if(minute)minute.textContent=String(Math.floor(remain/60)).padStart(2,'0');
        if(second)second.textContent=String(remain%60).padStart(2,'0');
        if(remain===0&&timer){clearInterval(timer);timer=null;}
      }
      draw();
      if(target>Date.now())timer=setInterval(draw,1000);
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',mount,{once:true});}
  else{mount();}
  document.addEventListener('shopify:section:load',mount);
})();